import React, { useState } from "react";
import refresh from "common-ui-components/components/icons/refresh.svg";
import tick from "../../TickMark.svg";
import styles from "./OverviewCards.module.css";
import InventorySummaryCard from "./InventorySummaryCard";
import EM_API from "common-ui-components/components/utils/API";
import { notify } from "../../../common-ui-components/components/notification/Notification";
import Success from "../../../common-ui-components/components/notification/templates/Success";
import Failure from "../../../common-ui-components/components/notification/templates/Failure";

const OverviewCards = ({
  cardsData,
  onRefreshComplete,
  hideHeader = false,
  loading = false,
}) => {
  const [status, setStatus] = useState("idle");

  const handleRefresh = async () => {
    setStatus("refreshing");

    try {
      const response = await EM_API.get("inventory/UpdateSummary");

      if (response.status.success) {
        notify(<Success>Summary Updated</Success>);
        // FIX: Call the parent's callback to trigger a data re-fetch
        if (onRefreshComplete) {
          onRefreshComplete();
        }
      } else {
        notify(<Failure>Refresh Failed</Failure>);
      }
    } catch (error) {
      console.error("API call failed:", error);
      notify(<Failure>Refresh Failed</Failure>);
    } finally {
      setStatus("complete");
      setTimeout(() => {
        setStatus("idle");
      }, 4000);
    }
  };
  return (
    <>
      <div
        className={`${styles.summaryCards} hideScrollbar`}
        style={{ width: "100%" }}
      >
        {!hideHeader && (
          <div
            style={{
              display: "flex",
              gap: "0.6rem",
              alignItems: "center",
            }}
          >
            <h3 style={{ fontFamily: "Inter, sans-serif" }}>Overview</h3>
            <div
              style={{ marginTop: "-0.8rem" }}
              className={styles.refreshIcon}
            >
              {status === "complete" ? (
                <img height={18} src={tick} alt="Complete" />
              ) : (
                <img
                  height={18}
                  src={refresh}
                  alt="refresh"
                  onClick={handleRefresh}
                  className={status === "refreshing" ? styles.rotate : ""}
                />
              )}
            </div>
          </div>
        )}
        <div className={styles.summaryGrid} aria-busy={loading}>
          {cardsData.map((cardData) => (
            <InventorySummaryCard
              key={cardData.heading}
              cardData={cardData}
              loading={loading}
              onClick={hideHeader ? null : cardData.handleCardClick}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export const OverviewCard = ({ cardData, scale }) => {
  return (
    <InventorySummaryCard
      cardData={cardData}
      onClick={cardData.handleCardClick}
      scale={scale}
    />
  );
};

export default OverviewCards;
